import * as React from 'react';
import { Alert, Link } from '@mui/material';
import { useGlobalization } from '../../contexts';
const AlertMessage = ({ children, type, bgColor, sideColor, showDismissBtn, onDismiss, textColor = '#4A6067', }) => {
    const styles = React.useMemo(() => {
        return {
            backgroundColor: bgColor,
            position: 'relative',
            color: textColor,
            '.MuiAlert-message': {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: '10px',
            },
            '.MuiAlert-icon': {
                color: textColor,
            },
            '&:before': {
                content: '""',
                width: '8px',
                height: '100%',
                backgroundColor: sideColor,
                position: 'absolute',
                top: 0,
                left: 0,
            },
        };
    }, [sideColor, textColor, bgColor]);
    const { t } = useGlobalization();
    const ref = React.useRef(null);
    const dismissAlert = () => {
        if (ref.current) {
            ref.current.style.display = 'none';
            onDismiss?.();
        }
    };
    return (React.createElement(Alert, { severity: type, sx: styles, ref: ref },
        children,
        showDismissBtn ? (React.createElement(Link, { style: {
                color: textColor,
            }, underline: "always", component: "button", variant: "body2", onClick: dismissAlert }, t('Dismiss'))) : null));
};
export default AlertMessage;
